<template>
  <div>
    <strong>{{ item }}:</strong>
    <span class="set-input-number">
      <a-input-number
        :default-value="datas.firstconfig.b[item] * 1"
        :min="0"
        :max="480"
        @change="setNum"
      />
      <em>{{ $t('message["304"]') }}</em>
    </span>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    item: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState('config/visit', ['datas'])
  },
  methods: {
    setNum (val) {
      this.datas.firstconfig.b[this.item] = val
    }
  }
}
</script>
